import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebac473c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"font-size":"64px"} }, "Settings", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Activated:", -1))
const _hoisted_4 = {
  key: 0,
  class: "o-87",
  slot: "end"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Onboarding Status:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "User #:", -1))
const _hoisted_7 = {
  key: 0,
  class: "o-87",
  slot: "end"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Roles:", -1))
const _hoisted_9 = {
  key: 0,
  class: "o-87",
  slot: "end"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "headline-5" }, "User Preferences", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Selected Region: ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Enable Reminder Notifications:", -1))
const _hoisted_13 = {
  key: 0,
  slot: "end"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "o-7 ma-0",
  slot: "end"
}, " Notifications are only supported on the mobile version ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Reminder Interval:", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Daily")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Weekly")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Monthly")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "headline-5" }, "Usage Statistics", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Highest Score:", -1))
const _hoisted_21 = {
  key: 0,
  class: "flex",
  slot: "end"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Lowest Score:", -1))
const _hoisted_23 = {
  key: 0,
  class: "flex",
  slot: "end"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Total Check-Ins:", -1))
const _hoisted_25 = {
  key: 0,
  class: "o-87 px-4",
  slot: "end"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"background":"#99ca3c"},
    class: "little-circle"
  }),
  /*#__PURE__*/_createTextVNode(" Biological Score Range:")
], -1))
const _hoisted_27 = {
  key: 0,
  class: "o-87 flex",
  slot: "end"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"background":"#0b789f"},
    class: "little-circle"
  }),
  /*#__PURE__*/_createTextVNode(" Psychological Score Range:")
], -1))
const _hoisted_29 = {
  key: 0,
  class: "o-87",
  slot: "end"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"background":"#f47b4b"},
    class: "little-circle"
  }),
  /*#__PURE__*/_createTextVNode(" Social Score Range:")
], -1))
const _hoisted_31 = {
  key: 0,
  class: "o-87",
  slot: "end"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, [
  /*#__PURE__*/_createElementVNode("span", {
    style: {"background":"#9a57a3"},
    class: "little-circle"
  }),
  /*#__PURE__*/_createTextVNode(" Spiritual Score Range:")
], -1))
const _hoisted_33 = {
  key: 0,
  class: "o-87",
  slot: "end"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Lowest Topic:", -1))
const _hoisted_35 = {
  key: 0,
  class: "body-2 o-87 my-capitalize",
  slot: "end"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Lowest Category:", -1))
const _hoisted_37 = {
  key: 0,
  class: "body-2 o-87 my-capitalize",
  slot: "end"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "headline-5" }, "App Details", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Version: ", -1))
const _hoisted_40 = {
  class: "body-2 o-87 my-capitalize",
  slot: "end"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-2" }, "Privacy Policy:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_notification_bell = _resolveComponent("notification-bell")!
  const _component_help_button = _resolveComponent("help-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_region_selector = _resolveComponent("region-selector")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_circle_progress = _resolveComponent("circle-progress")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, {
                slot: "start",
                class: "ion-hide-lg-up"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification_bell, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet
                  }, null, 8, ["parent"]),
                  _createVNode(_component_help_button)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center px-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "12" }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_row, { class: "pa-4 mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      class: "pa-4",
                      size: "12",
                      "size-lg": "8"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h5", {
                          class: "headline-5",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openWizardDialog && _ctx.openWizardDialog(...args)))
                        }, "Account Details"),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_4, _toDisplayString(_ctx.relativeDate(_ctx.userDetails.activated.seconds)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", {
                                  key: 0,
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDialog && _ctx.openDialog(...args))),
                                  class: "o-87 my-pointer",
                                  slot: "end"
                                }, _toDisplayString(_ctx.userDetails.wizardCompleted ? "complete" : "incomplete"), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_6,
                            (_ctx.user)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(_ctx.user.uid.slice(0, 10) + "..."), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_ctx.userDetails)
                          ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                              default: _withCtx(() => [
                                _hoisted_8,
                                (_ctx.user)
                                  ? (_openBlock(), _createElementBlock("h5", _hoisted_9, _toDisplayString(_ctx.userDetails.roles.join(', ')), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "8"
                    }),
                    _createVNode(_component_ion_col, {
                      class: "pa-4 mt-4",
                      size: "12",
                      "size-lg": "8"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_11,
                            _createVNode(_component_region_selector, { slot: "end" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_12,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_ion_toggle, {
                                    key: "notif-toggle",
                                    disabled: _ctx.loading || !_ctx.notificationsPossible,
                                    modelValue: _ctx.notificationsEnabled,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.notificationsEnabled) = $event)),
                                    onIonChange: _ctx.toggleNotifications
                                  }, null, 8, ["disabled", "modelValue", "onIonChange"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (!_ctx.notificationsPossible)
                          ? (_openBlock(), _createBlock(_component_ion_item, {
                              key: 0,
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_15,
                            _createVNode(_component_ion_select, {
                              slot: "end",
                              interface: "popover",
                              modelValue: _ctx.interval,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.interval) = $event)),
                              disabled: _ctx.loading || !_ctx.notificationsEnabled || !_ctx.notificationsPossible,
                              onIonChange: _ctx.toggleInterval
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_select_option, { value: "daily" }, {
                                  default: _withCtx(() => [
                                    _hoisted_16
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select_option, { value: "weekly" }, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select_option, { value: "monthly" }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "onIonChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      "size-lg": "8"
                    }),
                    _createVNode(_component_ion_col, {
                      class: "pa-4",
                      size: "12",
                      "size-lg": "8"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19,
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_20,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_21, [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_circle_progress, {
                                      "border-width": 8,
                                      "border-bg-width": 8,
                                      "empty-color": "#c6d6dc",
                                      "fill-color": "#92949c",
                                      size: 64,
                                      percent: _ctx.userDetails.highestTotal,
                                      "show-percent": ""
                                    }, null, 8, ["percent"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_22,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_23, [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_circle_progress, {
                                      "border-width": 8,
                                      "border-bg-width": 8,
                                      "empty-color": "#c6d6dc",
                                      "fill-color": "#92949c",
                                      size: 64,
                                      percent: _ctx.userDetails.lowestTotal,
                                      "show-percent": ""
                                    }, null, 8, ["percent"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_24,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_25, _toDisplayString(_ctx.userDetails.totalCheckIns), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_26,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_27, _toDisplayString(_ctx.userDetails.lowestBio) + "% - " + _toDisplayString(_ctx.userDetails.highestBio) + "% ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_28,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_29, _toDisplayString(_ctx.userDetails.lowestPsych) + "% - " + _toDisplayString(_ctx.userDetails.highestPsych) + "% ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_30,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_31, _toDisplayString(_ctx.userDetails.lowestSocial) + "% - " + _toDisplayString(_ctx.userDetails.highestSocial) + "% ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_32,
                            (_ctx.userDetails)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_33, _toDisplayString(_ctx.userDetails.lowestSpirit) + "% - " + _toDisplayString(_ctx.userDetails.highestSpirit) + "% ", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_34,
                            (_ctx.lowestTopic)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.lowestTopic.topic) + " : " + _toDisplayString(_ctx.lowestTopic.value), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_36,
                            (_ctx.lowestCategory)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.lowestCategory.category) + " : " + _toDisplayString(_ctx.lowestCategory.value), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      class: "pa-4 mt-2",
                      size: "12",
                      "size-lg": "8"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_38,
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.version), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, null, {
                          default: _withCtx(() => [
                            _hoisted_41,
                            _createElementVNode("div", {
                              class: "body-2 my-underline my-pointer",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args))),
                              slot: "end"
                            }, " Open ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}